<!-- 行业分类-编辑页 -->
<template>
  <div id="edit" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">
      {{ $route.query.ifEdit ? "编辑" : "新建" }}{{['','一','二','三','四','五','六','七','八','九','十'][($route.query.ifEdit ?(Number($route.query.tier)):(Number($route.query.tier)+1))]||'一'}}级行业
    </div>
    <!-- 编辑表单 -->
    <div class="edit_form">
      <el-form :model="tradeItem" :rules="rules" label-position="top" ref="tradeItem" label-width="100px" class="form_salesContract">
        <el-row :gutter="20">
          <!-- 行业名称 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="行业名称" prop="name">
              <el-input v-model="tradeItem.name" placeholder="请输入行业名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 所属上级行业 -->
          <el-col v-if="$route.query.tier&&$route.query.tierId" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="所属上级行业" required>
              <el-input v-model="tradeItem.tierName" placeholder="请输入行业名称" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 行业状态 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="行业状态" prop="status">
              <el-select v-model="tradeItem.status" placeholder="请选择目前所涉及的行业">
                <el-option v-for="(status,b) in statusList" :key="b" :label="status.name" :value="status.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 行业描述 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="行业描述">
              <el-input v-model="tradeItem.describe" placeholder="请输入行业描述" type="textarea" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button type="primary" @click="submitForm('tradeItem')" >保存</el-button> 
      <el-button plain @click="$router.push('/tradeManage')">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "edit",
  data() {
    return {
      tradeItem: { status: 1 },
      statusList: [{ id: 1, name: "启用" }, { id: 2, name: "停用" }],
      rules: {
        name: [
          { required: true, message: '请输入行业名称', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择行业状态', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.ifEdit) {//编辑跳转
      this.$set(this.tradeItem, "id", this.$route.query.id);
      this.getInfo();
    } else if (this.$route.query.tier) {//新增子级
      this.$set(this.tradeItem, 'tierName', this.$route.query.tierName);
      this.$set(this.tradeItem, 'tier', (Number(this.$route.query.tier) + 1));
      this.$set(this.tradeItem, 'parentId', this.$route.query.tierId);
    } else {
      this.$set(this.tradeItem, 'tier', 1);
    }
  },
  methods: {
    //获取信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryInfo`, { id: this.$route.query.id }).then((res) => {
          if (res.data.code == 200) {
            let form = Object.assign(this.tradeItem, res.data.data);
            this.tradeItem = JSON.parse(JSON.stringify(form));
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = `${process.env.BASE_URL}api/industry/addIndustry`;
          this.$axios
            .post(url, this.tradeItem).then(res => {
              if (res.data.code == 200) {
                this.$router.push('/tradeManage')
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            }).catch((err) => {
              console.log(err);
            });
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
// pc端
.edit_form {
  // margin-bottom: 80px;

  /deep/.el-input,
  /deep/.el-textarea {
    max-width: 500px;
  }

  /deep/.el-select,
  /deep/.el-date-editor {
    width: 300px;
  }
}

.pop_input /deep/.el-input__inner {
  font-size: 14px;
  padding: 0px 5px;
  height: 25px;
}

/deep/.el-popover {
  padding: 20px;
}
.list {
  display: flex;
  flex-direction: column;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;

    .el-icon-close {
      font-size: 18px;
      cursor: pointer;
    }

    .col {
      // display: flex;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .proAdd {
    justify-content: center;
    line-height: 18px;
    cursor: pointer;
  }

  .develirymed {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 15px 0;

    p {
      line-height: 15px;
    }
  }
}
/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .edit_form {
    /deep/.el-select,
    /deep/.el-date-editor {
      width: 70%;
    }
  }

  .flexStart {
    /deep/.el-select {
      width: 70%;
    }
  }
}
</style> 